import Crud from '../views/Classificacao/Crud'
import Entity from '../views/Classificacao/View'

let routes = {
    path: '/classificacoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/classificacoes/view/:id?',
            name: 'ViewClassificacao',
            component: Entity,
            meta: {
                pageTitle: 'Visualizar Classificação',
                breadcrumb: [
                    {
                        text: 'Classificações',
                        active: false,
                        to: '/classificacoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/classificacoes',
            name: 'list-classificacoes',
            component: Crud,
            meta: {
                pageTitle: "Lista de Classificações",
                breadcrumb: [
                    {
                        text: "Classificações",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
